module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-right-white-ee99e1566e57b308f0e6cfc454c6ff6d.svg";